/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNavFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterPrice_user" | "SbRespRefineMenuFilterDimensions_user">;
    readonly " $refType": "BuyRespTopNavFilters_user";
};
export type BuyRespTopNavFilters_user$data = BuyRespTopNavFilters_user;
export type BuyRespTopNavFilters_user$key = {
    readonly " $data"?: BuyRespTopNavFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyRespTopNavFilters_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNavFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'a3537f2d7cf46d23b4e59cd517eeddf3';
export default node;
